var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    {
      staticClass: "stretch-grid has-search",
      attrs: { id: "jobs-page", color: "white" }
    },
    [
      _c(
        "q-collapsible",
        {
          staticClass: "search-box",
          attrs: { "collapse-icon": "fa fa-angle-down" }
        },
        [
          _c("template", { slot: "header" }, [
            _c(
              "h5",
              { staticStyle: { padding: "12px 0px 12px 13px", width: "100%" } },
              [
                _c("q-icon", {
                  staticStyle: { padding: "0 5px 3px" },
                  attrs: { name: "fa fa-search", color: "primary" }
                }),
                _vm._v(" Jobs Search\n      ")
              ],
              1
            )
          ]),
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "sl-row no-margin" }, [
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-input", {
                      attrs: { "float-label": "Roster Job ID" },
                      model: {
                        value: _vm.searchFields.ROSTER_JOB_ID,
                        callback: function($$v) {
                          _vm.$set(_vm.searchFields, "ROSTER_JOB_ID", $$v)
                        },
                        expression: "searchFields.ROSTER_JOB_ID"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c(
                      "q-field",
                      [
                        _c("q-select", {
                          attrs: {
                            "float-label": "Roster Job Status",
                            options: _vm.rosterStatusOptions
                          },
                          model: {
                            value: _vm.searchFields.ROSTER_JOB_STATUS,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.searchFields,
                                "ROSTER_JOB_STATUS",
                                $$v
                              )
                            },
                            expression: "searchFields.ROSTER_JOB_STATUS"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c("q-input", {
                      attrs: { "float-label": "Class ID" },
                      model: {
                        value: _vm.searchFields.CLASS_ID,
                        callback: function($$v) {
                          _vm.$set(_vm.searchFields, "CLASS_ID", $$v)
                        },
                        expression: "searchFields.CLASS_ID"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "sl-row no-margin" }, [
                _c(
                  "div",
                  { staticClass: "sl-col-4" },
                  [
                    _c(
                      "q-field",
                      [
                        _c("q-select", {
                          attrs: {
                            "float-label": "Approval Status",
                            options: _vm.approvalStatusOptions
                          },
                          model: {
                            value: _vm.searchFields.LK_CLASS_APPROVAL_STATUS_ID,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.searchFields,
                                "LK_CLASS_APPROVAL_STATUS_ID",
                                $$v
                              )
                            },
                            expression:
                              "searchFields.LK_CLASS_APPROVAL_STATUS_ID"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "q-toolbar",
                {
                  staticStyle: { "padding-right": "60px" },
                  attrs: { color: "white" }
                },
                [
                  _c("q-toolbar-title"),
                  _c("q-btn", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: {
                      color: "secondary",
                      label: "Clear",
                      outline: "",
                      size: "sm",
                      type: "reset"
                    },
                    on: { click: _vm.fetchAndClear }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      label: "Search",
                      size: "sm",
                      type: "submit"
                    },
                    on: {
                      click: function($event) {
                        _vm.search()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c("Grid", {
        staticClass: "fit",
        attrs: {
          id: "jobsGrid",
          module: _vm.module,
          data: _vm.jobList,
          columns: _vm.columnOptions,
          pagination: _vm.pagination,
          onRequest: _vm.fetchAll,
          onLaunch: _vm.openJobModal,
          loading: _vm.loading,
          filterable: _vm.filterable,
          onColumnClick: _vm.onColumnClick
        },
        scopedSlots: _vm._u([
          {
            key: "col-item-status",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      blue: props.value == "Processing",
                      purple: props.value == "Ready for Review",
                      yellow: props.value == "In Review",
                      green: props.value == "Completed",
                      red: props.value == "Error"
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [_vm._v(_vm._s(props.value || "?"))]
                )
              ]
            }
          },
          {
            key: "col-item-user",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label green round small",
                    staticStyle: {
                      "font-size": "11px",
                      padding: "6px 0px",
                      "margin-right": "5px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.formatUserInitials(props.value)))]
                ),
                _vm._v(
                  "\n      " +
                    _vm._s(props.value.USER_FIRST_NAME) +
                    " " +
                    _vm._s(props.value.USER_LAST_NAME) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "col-item-approval_status",
            fn: function(props) {
              return [
                props.value
                  ? _c(
                      "div",
                      {
                        staticClass: "label small",
                        class: {
                          blue:
                            props.value == "SUBMITTED" ||
                            props.value == "RESUBMITTED",
                          green: props.value == "APPROVED",
                          red: props.value == "REJECTED",
                          yellow: props.value == "EXPIRED",
                          grey: props.value == "NOT SUBMITTED",
                          purple: props.value == "COMPLETED"
                        },
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "10px",
                          "border-radius": "30px",
                          "text-transform": "capitalize"
                        }
                      },
                      [_vm._v(_vm._s(props.value.toLowerCase()))]
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }